(function(){
    var ConfirmModal = function($el) {
        this.$el = $el
        this.$body = this.$el.find('.modal-body')
        this.$loader = this.$el.find('.loading')
        this.$submitButton = this.$el.find('.confirm-confirm-button')
        this.$eventButton = null

        this.$el.on('show.bs.modal', this.show.bind(this))
        this.$submitButton.on('click', this.submit.bind(this))

        return this
    }

    ConfirmModal.prototype.showLoader = function () {
        this.$submitButton.prop('disabled', true)
        this.$body.hide()
        this.$loader.fadeIn()
    }

    ConfirmModal.prototype.showBody = function () {
        this.$submitButton.prop('disabled', false)
        this.$loader.hide()
        this.$body.fadeIn()
    }

    ConfirmModal.prototype.show = function (event) {
        this.$eventButton = $(event.relatedTarget)
        this.$body.html(this.$eventButton.data('confirm-message'))
        this.showBody()
    }

    ConfirmModal.prototype.hide = function (event) {
        this.$el.trigger('sapphire.reload.tables');
        this.$el.modal('hide')
    }

    ConfirmModal.prototype.submit = function () {
        this.showLoader()

        var request = {
            method: 'post',
            url: this.$eventButton.data('confirm-url'),
            success: ((data) => {
                if (data && data.refresh && data.refresh == true) {
                    location.reload();
                }
            }),
            error: ((error) => {
                let message = error && error.responseJSON && error.responseJSON.message
                    ? error.responseJSON.message
                    : "Server Error"
                ;
                this.$loader.hide();
                this.$body.html(`<p class="text-danger">${message}</p>`);
                this.$body.fadeIn();
            })
        }

        $.ajax(request)
            .done(this.hide.bind(this))
    }

	$('.confirm-modal').each(function () {
		new ConfirmModal($(this))
	})
})()

